import { createSelector } from 'reselect';
import { Map, fromJS } from 'immutable';

import { getFormValues } from 'redux-form/immutable';
import { safeGet, safeGetIn } from '@/utils/safeImmutable';

export const getCustomFormIsTouched = () => (state: Map<any, any>) => safeGetIn(state, ['customForm', 'isTouched']);

export const getFormRegisteredFields = (formName: string) => (state: Map<any, any>) =>
  safeGetIn(state, ['form', formName, 'registeredFields']);

export const getFormSyncErrors = (formName: string) => (state: Map<any, any>) =>
  safeGetIn(state, ['form', formName, 'syncErrors']);

export const getExpandedCardIndex = () => (state: Map<any, any>) => safeGetIn(state, ['customForm', 'expandedCardIndex']);

export const getDefinedFormFieldSize = (formName: string, fieldName: string) =>
  createSelector(getFormValues(formName), (values: Map<any, any>) => {
    return values ? (values as any).get(fieldName).size : 0;
  });

export const getIsFormValid = (formName: string) =>
  createSelector(getFormSyncErrors(formName), (syncErrors: any) =>
    syncErrors ? fromJS(syncErrors).flatten().size === 0 : true,
  );

export const getFormInitialValues = (formName: string) => (state: Map<any, any>) =>
  safeGetIn(state, ['form', formName, 'initial']);
